import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TimelineComponent } from './components';
import { TimelineService } from './services';

@NgModule({
  imports: [CommonModule],
  exports: [TimelineComponent],
  declarations: [TimelineComponent],
  providers: [TimelineService],
})
export class TimelineModule {}
